/**
 * @desc 导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.storageDamageMaster.exportApply.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/storageDamageMaster/exportApply`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
